/* Product image viewer (owner 2026-10-13: "when image is clicked why no gallery or zoom"). Any element marked
 * [data-pl-zoom] (the product gallery's frame box, the kit page's) opens a full-screen viewer when one of its photos
 * is clicked or tapped: every photo of that gallery in order (product media and the theme's gallery images alike;
 * clips and videos stay in the page), arrows, swipe and arrow keys to move, a counter, thumbnails, Esc or X to close.
 * Click or tap a photo in the viewer to zoom in (2.5x, at that point), drag or move the pointer to look around, click
 * or tap again to zoom out. A native <dialog>: focus stays inside and returns to the gallery on close.
 * Large files: Shopify CDN URLs take a width, so the viewer asks for 2400 px of whatever the page shows. */
(function () {
  'use strict';
  if (window.__plZoom) return;
  window.__plZoom = true;
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'})[c]);
  const big = (src) => {
    if (!src) return '';
    const clean = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return clean + (clean.includes('?') ? '&' : '?') + 'width=2400';
  };
  const ZOOM = 2.5;
  let dlg = null;
  let list = [];
  let at = 0;
  let zoomed = false;
  let opener = null;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'pl-zoom';
    dlg.setAttribute('aria-label', 'Product images');
    dlg.innerHTML = '<div class="pl-zoom__bar"><span class="pl-zoom__count" aria-live="polite"></span>' +
      '<button type="button" class="pl-zoom__close" data-zoom-close aria-label="Close">&times;</button></div>' +
      '<div class="pl-zoom__stage"><img class="pl-zoom__img" alt="" draggable="false"></div>' +
      '<button type="button" class="pl-zoom__nav pl-zoom__nav--prev" data-zoom-step="-1" aria-label="Previous image">' +
      '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<button type="button" class="pl-zoom__nav pl-zoom__nav--next" data-zoom-step="1" aria-label="Next image">' +
      '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<div class="pl-zoom__thumbs" role="group" aria-label="Images"></div>';
    document.body.appendChild(dlg);
    const stage = dlg.querySelector('.pl-zoom__stage');
    const img = dlg.querySelector('.pl-zoom__img');

    dlg.addEventListener('click', (event) => {
      if (event.target.closest('[data-zoom-close]')) return close();
      const s = event.target.closest('[data-zoom-step]');
      if (s) return show(at + Number(s.dataset.zoomStep));
      const t = event.target.closest('[data-zoom-to]');
      if (t) return show(Number(t.dataset.zoomTo));
    });
    dlg.addEventListener('close', () => {
      document.documentElement.classList.remove('pl-zoom-open');
      if (opener) opener.focus({preventScroll: true});
    });
    dlg.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(at - 1);
      else if (event.key === 'ArrowRight') show(at + 1);
    });

    /* zoom: a click or tap without movement toggles it at that point; moving the pointer (mouse) or dragging
       (touch, pen) pans while zoomed; a horizontal swipe while not zoomed changes image */
    let down = null;
    let pan = {x: 0, y: 0};
    const apply = () => {
      img.style.transform = zoomed ? `translate(${pan.x}px, ${pan.y}px) scale(${ZOOM})` : '';
      stage.classList.toggle('is-zoomed', zoomed);
    };
    const clampPan = () => {
      /* offsetWidth/Height: the photo's laid-out size, before the zoom transform */
      const mx = (img.offsetWidth * ZOOM - stage.clientWidth) / 2;
      const my = (img.offsetHeight * ZOOM - stage.clientHeight) / 2;
      pan.x = Math.max(-Math.max(mx, 0), Math.min(Math.max(mx, 0), pan.x));
      pan.y = Math.max(-Math.max(my, 0), Math.min(Math.max(my, 0), pan.y));
    };
    const zoomAt = (cx, cy) => {
      const r = stage.getBoundingClientRect();
      zoomed = true;
      pan = {x: (r.left + r.width / 2 - cx) * (ZOOM - 1), y: (r.top + r.height / 2 - cy) * (ZOOM - 1)};
      apply();
      clampPan();
      apply();
    };
    stage.addEventListener('pointerdown', (event) => {
      down = {x: event.clientX, y: event.clientY, px: pan.x, py: pan.y, moved: false, type: event.pointerType};
      if (zoomed && event.pointerType !== 'mouse') stage.setPointerCapture(event.pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (!zoomed) {
        if (down) down.moved = down.moved || Math.abs(event.clientX - down.x) > 8;
        return;
      }
      if (event.pointerType === 'mouse' && !down) {
        const r = stage.getBoundingClientRect();
        pan = {x: (r.left + r.width / 2 - event.clientX) * (ZOOM - 1), y: (r.top + r.height / 2 - event.clientY) * (ZOOM - 1)};
      } else if (down) {
        pan = {x: down.px + (event.clientX - down.x), y: down.py + (event.clientY - down.y)};
        down.moved = down.moved || Math.abs(event.clientX - down.x) + Math.abs(event.clientY - down.y) > 8;
      } else {
        return;
      }
      clampPan();
      apply();
    });
    stage.addEventListener('pointerup', (event) => {
      if (!down) return;
      const dx = event.clientX - down.x;
      const dy = event.clientY - down.y;
      const d = down;
      down = null;
      if (!zoomed && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) return show(at + (dx < 0 ? 1 : -1));
      if (d.moved) return;
      if (zoomed) {
        zoomed = false;
        pan = {x: 0, y: 0};
        apply();
      } else if (event.target === img) {
        zoomAt(event.clientX, event.clientY);
      } else {
        close();
      }
    });
    stage.addEventListener('pointercancel', () => { down = null; });
    dlg.__reset = () => {
      zoomed = false;
      pan = {x: 0, y: 0};
      apply();
    };
  }

  function show(i) {
    if (!list.length) return;
    at = (i + list.length) % list.length;
    dlg.__reset();
    const it = list[at];
    const img = dlg.querySelector('.pl-zoom__img');
    img.src = it.small;
    img.alt = it.alt;
    const full = new Image();
    full.onload = () => { if (list[at] === it) img.src = it.large; };
    full.src = it.large;
    dlg.querySelector('.pl-zoom__count').textContent = `${at + 1} / ${list.length}`;
    dlg.querySelectorAll('.pl-zoom__nav').forEach((b) => { b.hidden = list.length < 2; });
    dlg.querySelectorAll('[data-zoom-to]').forEach((b, n) => {
      b.classList.toggle('is-active', n === at);
      if (n === at) {
        b.setAttribute('aria-current', 'true');
        b.scrollIntoView({block: 'nearest', inline: 'nearest'});
      } else {
        b.removeAttribute('aria-current');
      }
    });
    /* the next one loads now, so stepping never waits */
    const next = list[(at + 1) % list.length];
    if (next) new Image().src = next.large;
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  function open(box, startImg) {
    if (!dlg) build();
    /* photos grouped by colour (main-product): only the chosen colour's group and the shared photos */
    const gal = box.closest('[data-pl-gallery]');
    let group = null;
    if (gal && gal.dataset.plColorOption != null) {
      const on = gal.querySelector('.pl-pdp__thumb[data-pl-color]:not([hidden]):not([data-pl-color=""])');
      group = on ? on.dataset.plColor : null;
    }
    const imgs = [...box.querySelectorAll('.pl-pdp__frame:not(.pl-pdp__frame--video):not(.pl-pdp__frame--loop):not(.pl-pdp__frame--model) img')]
      .filter((im) => im.getAttribute('src') || im.currentSrc)
      .filter((im) => {
        const c = group == null ? '' : im.closest('.pl-pdp__frame').dataset.plColor;
        return !c || c === group;
      });
    list = imgs.map((im) => {
      const src = im.currentSrc || im.getAttribute('src');
      return {small: src, large: big(src), alt: im.alt || '', el: im};
    });
    if (!list.length) return;
    const start = Math.max(0, imgs.indexOf(startImg));
    dlg.querySelector('.pl-zoom__thumbs').innerHTML = list.length > 1 ? list.map((it, n) =>
      `<button type="button" class="pl-zoom__thumb" data-zoom-to="${n}" aria-label="Image ${n + 1} of ${list.length}"><img src="${esc(it.small.replace(/([?&])width=\d+/, '$1width=160'))}" alt="" loading="lazy"></button>`).join('') : '';
    opener = startImg.closest('[tabindex], button, a') || box;
    document.documentElement.classList.add('pl-zoom-open');
    dlg.showModal();
    show(start);
    dlg.querySelector('.pl-zoom__close').focus({preventScroll: true});
  }

  document.addEventListener('click', (event) => {
    const img = event.target.closest('[data-pl-zoom] .pl-pdp__frame img');
    if (!img) return;
    const frame = img.closest('.pl-pdp__frame');
    /* 3D frames (snippets/pl-pdp-3d) start their own viewer */
    if (frame.matches('.pl-pdp__frame--video, .pl-pdp__frame--loop, .pl-pdp__frame--model') || event.target.closest('button, a, video')) return;
    event.preventDefault();
    open(img.closest('[data-pl-zoom]'), img);
  });
  /* keyboard: the frame on show opens with Enter when the gallery box has focus */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('[data-pl-zoom]')) return;
    const img = [...event.target.querySelectorAll('.pl-pdp__frame:not([hidden]):not(.pl-pdp__frame--model) img')][0];
    if (img) open(event.target, img);
  });
})();
